import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Box,
  IconButton
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React from 'react';
import "react-toastify/dist/ReactToastify.css";

import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import useCodeEditorStore from '../store/codeEditorStore';
import PythonCompiler from './PythonCompiler';


const CodeDisplayModal = () => {
  const { openCodeEditor, setOpenCodeEditor } = useCodeEditorStore()
  return (
    <Box className="data_preview">
      <Dialog height={900}
        style={{ margin: "10px" }}
        open={openCodeEditor}
        onClose={() => setOpenCodeEditor(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
        fullWidth
      >
 
        <IconButton
          aria-label="close"
          onClick={() => {
            setOpenCodeEditor(false);
          }}
          sx={{
            position: "absolute",
            right: 2,
            top: 2,
          }}
        >
          <HighlightOffIcon fontSize="small" className="gray" />
        </IconButton>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box className="text_area">
              <Box className="input_field">
                <PythonCompiler />
              </Box>

            </Box>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Box>
  )
}

export default CodeDisplayModal